import type { JSX } from 'react';
import { useContent } from '@data';
import { useT } from '@/i18n';
import { SectionHeader, RevealWrapper, SkillBar } from '@components/ui';
import './Skills.css';

export default function Skills(): JSX.Element {
  const { SKILL_GROUPS } = useContent();
  const t = useT();

  return (
    <section id="competences" className="section Skills">
      <SectionHeader
        chip={t.sections.skills.chip}
        chipVariant="t"
        title={t.sections.skills.title}
        subtitle={t.sections.skills.subtitle}
      />

      <div className="Skills__grid">
        {SKILL_GROUPS.map((group, gi) => (
          <RevealWrapper key={group.label} delay={gi + 1}>
            <div className="SkillGroup">
              <h3 className="SkillGroup__label">{group.label}</h3>
              <div className="SkillGroup__bars">
                {group.skills.map(skill => (
                  <SkillBar
                    key={skill.name}
                    name={skill.name}
                    percentage={skill.percentage}
                    colorVar={skill.colorVar}
                  />
                ))}
              </div>
            </div>
          </RevealWrapper>
        ))}
      </div>
    </section>
  );
}
